export const FETCH_TOEGANGSCONTROLES = 'fetch_toegangscontroles';
export const FETCH_TOEGANGSCONTROLE = 'fetch_toegangscontrole';
export const SAVE_TOEGANGSCONTROLE = 'save_toegangscontrole';
export const TOGGLE_TOEGANGSCONTROLE = 'toggle_toegangscontrole';
export const TEST_TOEGANGSCONTROLE = 'test_toegangscontrole';
export const START_AUTHORIZATION = 'start_authorization';
export const REFRESH_TOKEN = 'refresh_token';
export const TOEGANGSCONTROLE_ERROR = 'toegangscontrole_error';